import React, { useEffect, useState } from "react";
import Instrument_Check_Form from "./instrument_Check_Form/Instrument_Check_Form";
import Instrument_Check_table from "./instrument_Check_table/Instrument_Check_table";
import { useDispatch, useSelector } from "react-redux";
import { GetAllInstrument } from "../../../../../../../features/admin/quality_management/resource_requirement/equipment/Slice";
import { FixIDS } from "../../../../../../../utils/fixIDS";

function Instrument_Check({ all_instruments }) {

  const [success, setSuccess] = useState(false);
  const [showTable, setShowTable] = useState(false);
  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState(1);
  const [searchName, setSearchName] = useState({
    unique_id: "",
    instrument_name: "",
    calibration_status_id: "",
    calibrated_id: "",
  });

  const data = useSelector((state) => state.equipment.data_instrument);
  const fetchCustomers = async (page = 1) => {
    await dispatch(
      GetAllInstrument({
        instrument_id: searchName.instrument_id || "",
        instrument_unique_id: searchName.instrument_unique_id || "",
        calibrate_instrument: searchName.calibrate_instrument || "",
        page: page,
        // per_page: data?.data.per_page,
      }),
    );
  };

  const permissions = useSelector((state) => state.auth.permissions);
                      
  const haveReadPermission = permissions?.includes(FixIDS.instrument_check.List);
  const haveAddPermission = permissions?.includes(FixIDS.instrument_check.Add);

  useEffect(() => {
    fetchCustomers(currentPage);
  }, [currentPage, success]);

  return (
    <>
      <div className="imperiality_Form_div">
        { haveAddPermission && <Instrument_Check_Form
          onProceed={() => setShowTable(true)}
          all_instruments={all_instruments}
          fetchCustomers={fetchCustomers}
        /> }
      </div>

      {/* {showTable && ( */}
      <div className="imperiality_table_div">
       { haveReadPermission &&  <Instrument_Check_table
          data={data}
          setCurrentPage={setCurrentPage}
          currentPage={currentPage}
          setSuccess={setSuccess}
          fetchCustomers={fetchCustomers}
          
        /> }
      </div>
      {/* )} */}
    </>
  );
}

export default Instrument_Check;
